import React, { useState, useEffect } from 'react'
import { Box, Grid, TextField, Button } from '@mui/material'
// import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import { useCreateCardDetailContext } from '../../../CreatecardDetailContext';
import { CgColorPicker } from "react-icons/cg";
import QrcodePic1 from "../../../../Assets/img/CardsPart/QrCode-Type-1.svg"
import QrcodePic2 from "../../../../Assets/img/CardsPart/QrCode-Type-2.svg"
import QrcodePic3 from "../../../../Assets/img/CardsPart/QrCode-Type-3.svg"
import QrcodePic4 from "../../../../Assets/img/CardsPart/QrCode-Type-4.svg"
import QrcodePic5 from "../../../../Assets/img/CardsPart/QrCode-Type-5.svg"
import QrCodeImage from "../../../../Assets/img/CardsPart/QrCode-Image.svg"
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
// import FileDragUpload from './FileDragUpload';
import axios from 'axios';
import { useQuantityContext } from '../../../QuantityContext';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as TickIcon } from "../../../../Assets/img/icons/tick-shape.svg";
import { useDispatch } from 'react-redux';
import { getAllCardDetailsReducer, getAllCardInfoReducer } from '../../../../Redux/Reducers/CardReducer';

const Qrcode = ({ handleSuccess, handleFailure }) => {
  const { CardQrStyles, updateCardQrStyles } = useCreateCardDetailContext();

  const handleInputChange = (fieldName) => (event) => {
    const newValue = event.target.value;
    console.log(newValue);
    updateCardQrStyles({ [fieldName]: newValue });
  };
  const handleBgOptionChange = (event) => {
    updateCardQrStyles({ addbgcolor: "#ffff" })
  };

  const [SaveEnable, setSaveEnable] = useState(false);
  const [initialQrStyles, setInitialQrStyles] = useState({});
  const { setisNavigationBlocked, handleInfo } = useQuantityContext();

  useEffect(() => {
    setInitialQrStyles(CardQrStyles);
  }, []);

  useEffect(() => {
    setSaveEnable(JSON.stringify(initialQrStyles) !== JSON.stringify(CardQrStyles));
    setisNavigationBlocked(JSON.stringify(initialQrStyles) !== JSON.stringify(CardQrStyles));
  }, [CardQrStyles, initialQrStyles]);

  const [selectedEyeBall, setSelectedEyeBall] = useState("");
  const [selectedShape, setSelectedShape] = useState("");
  const [selectedPattern, setSelectedPattern] = useState("");
  const [selectedBorder, setSelectedBorder] = useState(CardQrStyles?.border || ''); // State to track selected border

  const handleShapeSelection = (shape, fieldName) => {
    setSelectedShape(shape);
    updateCardQrStyles({ [fieldName]: shape });
  };

  const handleEyeBallSelection = (eyeBall, fieldName) => {
    setSelectedEyeBall(eyeBall);
    updateCardQrStyles({ [fieldName]: eyeBall });
  };
  const dispatch = useDispatch();
  const handlePatternSelection = (pattern, fieldName) => {
    setSelectedPattern(pattern);
    updateCardQrStyles({ [fieldName]: pattern });
  };
  const handleBorderSelection = (border, fieldName) => {
    setSelectedBorder(border);
    updateCardQrStyles({ [fieldName]: border });
  };
  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${objectId}`


  };

  const handleSave = async (event) => {
    event.preventDefault();

    if (CardQrStyles?.CardType?.startsWith("Customize_") && (CardQrStyles.CardName === '' || CardQrStyles.CardName === null)) {
      // alert("CardName should not be Empty");
      handleInfo("CardName should not be Empty");
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/card/cardQrStyles`, CardQrStyles,
        { headers: headers }
      );
      console.log('Response from backend:', response.data);
      dispatch(getAllCardDetailsReducer());
      dispatch(getAllCardInfoReducer());

      setInitialQrStyles(CardQrStyles);
      handleSuccess();
    }
    catch (error) {
      console.error('Error submitting card details:', error);
      handleFailure();
    }
  };

  return (
    <div>
      {/* <Box className='my-4 card-info-box' sx={{ border: "1px solid #17b200", backgroundColor: "white", borderRadius: 2, padding: "16px" }}> */}
      <div className='px-3'>
        <div className="card-edit-info-heading">
          <h5>Customize QR Code</h5>
          <span>Customize your QR code frame and color.</span>
        </div>
        {/*   <div className='my-2 add-logo-container text-left'>
          <h5>Add Logo</h5> 
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <FileDragUpload label="Add Logo" contextKey="logoQr" accept={['image/jpeg', 'image/png']} maxSize={500000} inputId="logoQr_Image" />
            </Grid>
          </Grid>
        </div>*/}

        <div className="my-3">
          <h5>Select Eye-ball</h5>
          <Grid container spacing={2}>
            {/* First Column */}
            <Grid item xs={12} container>
              <div className={`me-2 shape-qrcode flex-center ${selectedEyeBall === 'square' ? 'selected' : ''}`} onClick={(e) => { handleEyeBallSelection('square', 'eyeBall'); }}><span className='square'></span></div>
              <div className={`mx-2 shape-qrcode flex-center ${selectedEyeBall === 'extra-rounded' ? 'selected' : ''}`} onClick={(e) => { handleEyeBallSelection('extra-rounded', 'eyeBall'); }}><span className='square-rounded'></span></div>
              <div className={`mx-2 shape-qrcode flex-center ${selectedEyeBall === 'dot' ? 'selected' : ''}`} onClick={(e) => { handleEyeBallSelection('dot', 'eyeBall'); }}><span className='circle'></span></div>
            </Grid>                                            {/*  handleInputChange('eyeBall')   */}
          </Grid>
          <p className='mb-1 pt-1'>Eye-ball Color
          </p>
          <Grid container spacing={2}>
            {/* <Grid item xs={5}>
              <TextField
                value={CardQrStyles?.eyeBallcolor || ''}
                onChange={(e) => {
                  handleInputChange('eyeBallcolor')(e);
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <div className="icon-color-picker d-flex align-items-center justify-content-center">
                <label className="color-picker-label">
                  <CgColorPicker className="color-picker-icon" />
                  <input
                    type='color'
                    className="color-picker-input"
                    onChange={(e) => {
                      handleInputChange('eyeBallcolor')(e);
                    }}
                  />
                </label>
              </div>
            </Grid> */}

            <Grid item xs={5}>
              <TextField
                value={CardQrStyles?.eyeBallcolor || ''}
                onChange={(e) => {
                  handleInputChange('eyeBallcolor')(e);
                }}
                className='color-picker-field card-designer'
                fullWidth
                InputProps={{
                  endAdornment:
                    <div className="icon-color-picker card-designer" style={{ backgroundColor: CardQrStyles?.eyeBallcolor || "" }}>
                      <input
                        type='color'
                        className="color-picker-input"
                        onChange={(e) => {
                          handleInputChange('eyeBallcolor')(e);
                        }}
                        defaultValue={CardQrStyles?.eyeBallcolor || '#000000DE'}
                      />
                    </div>
                }}
              />
            </Grid>
          </Grid>
        </div>

        <div className="my-3">
          <h5>Select Eye-frame</h5>
          <Grid container spacing={2}>
            {/* First Column */}
            <Grid item xs={12} container>
              <div className={`me-2 shape-qrcode flex-center ${selectedShape === 'square' ? 'selected' : ''}`} onClick={() => { handleShapeSelection('square', 'eyeFrame'); }}><span className='square-border'></span></div>
              {/* <div className={`mx-2 shape-qrcode flex-center ${selectedShape === 'rounded' ? 'selected' : ''}`} onClick={() => { handleShapeSelection('rounded', 'eyeFrame') }}><span className='square-rounded-border'></span></div> */}
              <div className={`mx-2 shape-qrcode flex-center ${selectedShape === 'circle' ? 'selected' : ''}`} onClick={() => { handleShapeSelection('circle', 'eyeFrame') }}><span className='circle-border'></span></div>
              {/* <div className={`mx-2 shape-qrcode flex-center ${selectedShape === 'left-bottom' ? 'selected' : ''}`} onClick={() => { handleShapeSelection('Classic', 'eyeFrame') }}><span className='Square-left-bottom'></span></div> */}
              {/* <div className={`mx-2 shape-qrcode flex-center ${selectedShape === 'right' ? 'selected' : ''}`} onClick={() => { handleShapeSelection('Classy Rounded', 'eyeFrame') }}><span className='Square-right'></span></div> */}
            </Grid>
          </Grid>
          <p className='mb-1 pt-1'>Eye-frame Color</p>
          <Grid container spacing={2}>
            {/* <Grid item xs={5}>
              <TextField
                value={CardQrStyles?.eyeFrameColor || ''}
                onChange={(e) => {
                  handleInputChange('eyeFrameColor')(e);
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <div className="icon-color-picker d-flex align-items-center justify-content-center">
                <label className="color-picker-label">
                  <CgColorPicker className="color-picker-icon" />
                  <input
                    type='color'
                    className="color-picker-input"
                    onChange={(e) => {
                      handleInputChange('eyeFrameColor')(e);
                    }}
                  />
                </label>
              </div>
            </Grid> */}

            <Grid item xs={5}>
              <TextField
                value={CardQrStyles?.eyeFrameColor || ''}
                onChange={(e) => {
                  handleInputChange('eyeFrameColor')(e);
                }}
                className='color-picker-field card-designer'
                fullWidth
                InputProps={{
                  endAdornment:
                    <div className="icon-color-picker card-designer" style={{ backgroundColor: CardQrStyles?.eyeFrameColor || '' }}>
                      <input
                        type='color'
                        className="color-picker-input"
                        onChange={(e) => {
                          handleInputChange('eyeFrameColor')(e);
                        }}
                        defaultValue={CardQrStyles?.eyeFrameColor || '#000000DE'}
                      />
                    </div>
                }}
              />
            </Grid>
          </Grid>
        </div>


        <div className="my-2">
          <h5>Select Pattern</h5>
          <Grid container spacing={2}>
            {/* First Column */}
            <Grid item xs={12} container>
              <div className={`me-2 border-above-qr ${selectedPattern === 'square' ? 'selected' : ''}`} onClick={() => handlePatternSelection('square', 'qrPattern')}><img src={QrcodePic1} alt="Qrcode1" /></div>
              <div className={`mx-2 border-above-qr ${selectedPattern === 'rounded' ? 'selected' : ''}`} onClick={() => handlePatternSelection('rounded', 'qrPattern')}><img src={QrcodePic2} alt="Qrcode2" /></div>
              <div className={`mx-2 border-above-qr ${selectedPattern === 'dots' ? 'selected' : ''}`} onClick={() => handlePatternSelection('dots', 'qrPattern')}><img src={QrcodePic3} alt="Qrcode3" /></div>
              <div className={`mx-2 border-above-qr ${selectedPattern === 'classy' ? 'selected' : ''}`} onClick={() => handlePatternSelection('classy', 'qrPattern')}><img src={QrcodePic4} alt="Qrcode4" /></div>
              <div className={`mx-2 border-above-qr ${selectedPattern === 'classy-rounded' ? 'selected' : ''}`} onClick={() => handlePatternSelection('classy-rounded', 'qrPattern')}><img src={QrcodePic5} alt="Qrcode5" /></div>
            </Grid>
          </Grid>
          <p className='mb-1 pt-1'>Pattern Color</p>
          <Grid container spacing={2}>
            {/* <Grid item xs={5}>
              <TextField
                value={CardQrStyles?.qrPatterncolor || ''}
                onChange={(e) => {
                  handleInputChange('qrPatterncolor')(e);
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <div className="icon-color-picker d-flex align-items-center justify-content-center">
                <label className="color-picker-label">
                  <CgColorPicker className="color-picker-icon" />
                  <input
                    type='color'
                    className="color-picker-input"
                    onChange={(e) => {
                      handleInputChange('qrPatterncolor')(e);
                    }}
                  />
                </label>
              </div>
            </Grid> */}

            <Grid item xs={5}>
              <TextField
                value={CardQrStyles?.qrPatterncolor || ''}
                onChange={(e) => {
                  handleInputChange('qrPatterncolor')(e);
                }}
                className='color-picker-field card-designer'
                fullWidth
                InputProps={{
                  endAdornment:
                    <div className="icon-color-picker card-designer" style={{ backgroundColor: CardQrStyles?.qrPatterncolor || '' }}>
                      <input
                        type='color'
                        className="color-picker-input"
                        onChange={(e) => {
                          handleInputChange('qrPatterncolor')(e);
                        }}
                        defaultValue={CardQrStyles?.qrPatterncolor || ''}
                      />
                    </div>
                }}
              />
            </Grid>
          </Grid>
        </div>

        <div className="my-3">
          <h5>Select Border</h5>
          <Grid container spacing={2}>
            {/* First Column */}
            {/* <Grid item xs={12} container>
                <div className='div-qr-code flex-center'> <img src={QrCodeImage} alt="qrcode" /></div>
                <div className='mx-2 div-qr-code flex-center'> <img className='border-qr-code' src={QrCodeImage} alt="qrcode" /></div>
              </Grid> */}
            <Grid item xs={12} container>
              <div className={`div-qr-code flex-center ${selectedBorder === 'no-border' ? 'selected' : ''}`} onClick={() => handleBorderSelection('no-border', 'border')}><img src={QrCodeImage} alt="qrcode" /></div>
              <div className={`mx-2 div-qr-code flex-center ${selectedBorder === 'border' ? 'selected' : ''}`} onClick={() => handleBorderSelection('border', 'border')}><img className='border-qr-code' src={QrCodeImage} alt="qrcode" /></div>
            </Grid>

          </Grid>
          <p className='mb-1 pt-1'>Border Color</p>
          <Grid container spacing={2} sx={{ alignItems: "center" }}>
            {/* <Grid item xs={5}>
              <TextField
                value={CardQrStyles?.bordercolor || ''}
                onChange={(e) => {
                  handleInputChange('bordercolor')(e);
                }}
                fullWidth
                disabled={selectedBorder === 'no-border'}
              />
            </Grid>
            <Grid item xs={3}>
              <div className="icon-color-picker d-flex align-items-center justify-content-center">
                <label className="color-picker-label">
                  <CgColorPicker className="color-picker-icon" />
                  <input
                    type='color'
                    className="color-picker-input"
                    onChange={(e) => {
                      handleInputChange('bordercolor')(e);
                    }}
                    disabled={selectedBorder === 'no-border'}
                  />
                </label>
              </div>
            </Grid> */}

            <Grid item xs={5}>
              <TextField
                value={CardQrStyles?.bordercolor || '#00000099'}
                onChange={(e) => {
                  handleInputChange('bordercolor')(e);
                }}
                className='color-picker-field card-designer'
                fullWidth
                InputProps={{
                  endAdornment:
                    <div className="icon-color-picker card-designer" style={{ backgroundColor: CardQrStyles?.bordercolor || '#00000099' }}>
                      <input
                        type='color'
                        className="color-picker-input"
                        onChange={(e) => {
                          handleInputChange('bordercolor')(e);
                        }}
                        defaultValue={CardQrStyles?.eyeFrameColor || '#00000099'}
                        disabled={selectedBorder === 'no-border'}
                      />
                    </div>
                }}
              />
            </Grid>
          </Grid>
        </div>

        <div className="my-3">
          <h5>Add Background</h5>
          <Grid container spacing={2}>
            {/* First Column */}
            <Grid item xs={12} container>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="Color"
                  name="radio-buttons-group"
                  row
                  onChange={(e) => { handleBgOptionChange(); handleInputChange('addbg')(e) }}
                >
                  <FormControlLabel value="Color" control={<Radio />} label="Color" />
                  <FormControlLabel value="Transparent" control={<Radio />} label="Transparent" />
                </RadioGroup>
              </FormControl>

            </Grid>
          </Grid>
          {CardQrStyles?.addbg !== "Transparent" &&
            <Grid container spacing={2} sx={{ alignItems: "center" }}>
              <Grid item xs={5}>
                <TextField
                  value={CardQrStyles?.addbgcolor || ''}
                  onChange={(e) => handleInputChange('addbgcolor')(e)}
                  className='color-picker-field card-designer'
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <div
                        className="icon-color-picker card-designer"
                        style={{ backgroundColor: CardQrStyles?.addbgcolor || '' }}
                      >
                        <input
                          type='color'
                          className="color-picker-input"
                          onChange={(e) => handleInputChange('addbgcolor')(e)}
                          value={CardQrStyles?.addbgcolor || '#000000DE'}
                          disabled={(CardQrStyles?.addbg === "Transparent")}
                        />
                      </div>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          }
        </div>

      </div>
      {/* </Box> */}
      <div className="save-bottom" style={{ textAlign: "right", backgroundColor: "#0044C614", padding: "12px", borderRadius: "0 0 8px 8px" }}>
        <Button variant='contained' sx={{ backgroundColor: "#0044C6" }} onClick={handleSave} disabled={!SaveEnable}>Save</Button>
      </div>
      <ToastContainer toastClassName="email-toast-success" />
    </div>
  )
}

export default Qrcode